import { useState, useEffect } from "react";
import { database } from "../config/firebase";
import {
  ref,
  get,
  set,
  update,
  remove,
  child,
  onValue,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";
import { UserAuth } from "../context/AuthContext";

const useFetch = () => {
  const [data, setData] = useState([]);
  const [parentData, setParentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = UserAuth();

  useEffect(() => {
    const fetchResource = async () => {
      try {
        const parentRef = ref(database, "users/" + user.uid);
        onValue(parentRef, (snapshot) => {
          if (snapshot.exists()) {
            const pData = snapshot.val();
            pData.id = snapshot.key;
            setParentData(pData);
            
            const accessCode = pData.accessCode;
            // Usuarios sin accessCode (p. ej. maestros) no tienen aprendiz asociado:
            // no consultamos por accessCode (equalTo(undefined) revienta) y liberamos la carga.
            if (!accessCode) {
              setData(null);
              setLoading(false);
              return;
            }
            const res = query(
            ref(database, "users"),
            orderByChild("accessCode"),
            equalTo(accessCode)
          );
          onValue(res, (snapshot) => {
            let dataItem = null;
            if (snapshot.exists()) {
              snapshot.forEach((item) => {
                if (item.val().username) {
                  dataItem = item.val();
                  dataItem.id = item.key;
                }
              });
            }
            setData(dataItem);
            setLoading(false);
          });
          }
        });
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchResource();
  }, []);

  return { data, parentData, loading, error };
};

export default useFetch;
